export default "__VITE_ASSET__BalRnAMO__"